import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { scCatchServiceException } from "../../annotations";
import { CancelToken } from "axios";
import { Page, SegmentationDetail } from "../../services/bedrock";

const SEGMENTATION_DETAIL_SERVICE = `${Constants.API_URL}/bedrock/segmentation_details`;

export class SegmentationDetailServices {
  @scCatchServiceException()
  static async getSegmentationDetails(
    types?: string[],
    search?: string,
    page = 1,
    perPage = 25,
    cancelToken?: CancelToken
  ): Promise<Page<SegmentationDetail>> {
    const url = SEGMENTATION_DETAIL_SERVICE;
    const { data } = await axios.get<Page<SegmentationDetail>>(url, {
      params: {
        types,
        search,
        page,
        perPage,
      },
      cancelToken,
    });
    return data;
  }
}
